export const scrollToCompra = (e?: React.MouseEvent) => {
  if (e) e.preventDefault()
  const el = document.getElementById('compra')
  if (el) {
    // Add a slight offset for sticky headers if any, otherwise standard scroll
    const y = el.getBoundingClientRect().top + window.scrollY - 20
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}
